import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../../../../../Redux/actions/userActions";
import * as instanceActions from "../../../../../Redux/api";
import { getUserByCode } from "../../../../../Redux/reducer/users";
import { getRoles } from "../../../../../Redux/reducer/session";
import { MOD_PROVID, WRITE } from "../../../../../permissions/";
import Provider from "../../../../../../static/images/user-add-grey.svg";
import iconEdit from "../../../../../../static/images/icon-addnew-18px.svg";
import iconCredentials from "../../../../../../static/images/reset-credentials.svg";
import i18next from "i18next";
import CheckBox from "canvas-core-react/lib/Checkbox";

import Modal from "../../../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  moduleAction,
  infoContainer,
  successModal,
  invalidPhoneNumber,
  includeSpecialCharacters,
  invalidPhoneLastCharacter,
} from "../../../../utils/functions";
import CustomSelect from "../../../../shared/custom-components/select";
import Tooltip from "canvas-core-react/lib/Tooltip";
import CustomInput from "../../../../shared/custom-components/customInput";

const options = [
  {
    name: "firstName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "lastName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "phone",
    validation: invalidPhoneNumber,
    msg: "invalidPhoneNumber",
  },
  {
    name: "phone",
    validation: invalidPhoneLastCharacter,
    msg: "invalidPhoneLastCharacter",
  },
];

export class ProviderUserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: true,
        content: loadingHtml(),
        onClose: undefined,
      },
      errors: {},
      submitted: false,
      modulo: [],
      contentReady: false,
      checkedModule: [],
      check: false,
      selectedStatus: {},
      user: {},
      readOnly: true,
    };
  }

  componentDidMount() {
    const {
      actions: { getUserByCod },
    } = this.props;

    const { modal } = this.state;
    modal.show = true;
    this.setState({ modal });

    return getUserByCod(
      this.props.user.userCode,
      this.props.user.businessId,
      "PRO",
      this.props.user.countryCode
    ).then((response) => {
      var user = response.data;
      modal.show = false;
      this.setState({
        contentReady: true,
        modal,
        user: this.getDefaultUser(user),
        // modulo: this.searchModule(user.modules),
        modulo: user.modules,
      });
    });
  }

  componentWillUnmount() {
    this.setState({ contentReady: false, user: {}, modulo: [] });
  }

  getDefaultUser = (user) => {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      id: user.identification,
      phone: user.phone,
      email: user.email,
      companyState: user.status,
      idUser: user.id,
    };
  };

  searchModule = (modulo) => {
    var modBill = null;
    modulo.map((modulo) => {
      if (modulo.code === "MOD_BILL") {
        modBill = modulo;
      }
    });
    return modBill;
  };

  SelectedStatus = (event) => {
    const { selectedStatus } = this.state;

    const value = event.target.value;
    const name = event.target.name;
    selectedStatus[name] = value;

    this.setState({ selectedStatus });
  };

  getUserData = () => {
    const { user, modulo } = this.state;
    var modules = [];
    modulo.map((mod) => {
      let permissions = [];
      Object.keys(mod.permissions).map((key) =>
        permissions.push({
          id: parseInt(mod.permissions[key].id, 10),
          assigned: mod.permissions[key].assigned,
        })
      );

      modules.push({ id: mod.id, permissions });
    });
    return {
      data: {
        codUser: this.props.user.userCode,
        email: user.email,
        firstName: user.firstName,
        identification: user.id,
        lastName: user.lastName,
        phone: user.phone,
        status: this.state.selectedStatus.companyStatus,
        modules,
      },
    };
  };

  moduleHandlerChange = (event) => {
    const { modulo } = this.state;
    var modId = event.target.name.split("-")[0];
    var permissionId = event.target.name.split("-")[1];
    if (modulo[modId].permissions[permissionId] !== undefined) {
      modulo[modId].permissions[permissionId].assigned = event.target.checked;
    }
    this.setState({ modulo });
  };

  nextStep = () => {
    this.props.history.push("/bscadministrator/providers");
  };

  modalFunction = () => {
    var buttons = {
      SelBtn: {
        text: "Aceptar",
        action: this.nextStep,
      },
    };

    var content = infoContainer(
      "Usuario",
      `Los datos del usuario han sido actualizados con éxito.
      Diríjase al menú de admisiones para su aprobación.`,
      buttons
    );
    this.setState({ modal: { content, show: true } });
  };

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.content = loadingHtml();
    modal.onClose = undefined;
    this.setState({ modal });
  };

  handlerChange = (event) => {
    var name = event.target.name,
      value = event.target.value;
    const { user, submitted } = this.state;

    user[name] = value;

    this.setState({
      user,
      errors: submitted ? this.handleErrors(user) : {},
    });
  };

  handleErrors = (provider) => {
    return options.reduce((acc, { name, validation, msg }) => {
      if (validation(provider[name]))
        if (!acc[name]) acc[name] = i18next.t(`general.formErrors.${msg}`);
      return acc;
    }, {});
  };

  UpdateProviderUser = (event) => {
    event.preventDefault();
    const {
      instance: { instanceAction },
    } = this.props;

    const { modal } = this.state;

    const data = this.getUserData();
    const errors = this.handleErrors(data.data);

    this.setState({ errors, submitted: true });

    if (Object.keys(errors).length) return;
    else this.setState({ modal: { ...modal, show: true } });

    return instanceAction(
      `users/provider/${this.props.user.businessId}/${this.props.user.countryCode}`,
      "put",
      data
    )
      .then(() => {
        this.modalFunction();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          const buttons = {
            continueBtn: {
              text: "Aceptar",
              action: this.closeModal,
            },
          };
          const content = errorContainer(
            notification.message,
            notification.description,
            buttons
          );
          modal.onClose = () => this.closeModal;
          this.setState({ modal: { content, show: true } });
        }
      });
  };

  pendingData = (attribute) => {
    const { user } = this.state;
    const userComplete = { ...this.props.userInfo };
    var data =
      userComplete.recordsTmp !== null ? userComplete.recordsTmp.data : null;
    return (
      data !== null &&
      data[attribute] !== undefined &&
      data[attribute] !== user[attribute] && (
        <div className="flex-element">
          <label className="edited-client-info" htmlFor={attribute}>
            Espacio pendiente de aprobación
          </label>
          <div className="left-flex fix-tooltip">
            <Tooltip
              id="tooltip-id"
              closeButtonLabel="Close Tooltip"
              infoButtonLabel="Info"
              heading={"Pendiente de aprobación"}
            >
              <label
                className="edited-client-info tooltip-color"
                htmlFor={attribute}
              >
                {`De aprobarse el cambio este campo cambiaría su valor de ${user[attribute]} por ${data[attribute]}`}
              </label>
            </Tooltip>
          </div>
        </div>
      )
    );
  };

  resetCredentialsFunction = (codUser) => {
    const { modal } = this.state;
    const {
      instance: { instanceAction },
    } = this.props;
    modal.content = loadingHtml();
    modal.show = true;

    this.setState({ modal });
    return instanceAction(`users/update-for-recover-credentials`, "put", {
      idUser: codUser,
    })
      .then(() => {
        modal.content = successModal("¡Las credenciales han sido cambiadas!");
        modal.onClose = () => this.closeModal();

        this.setState({ modal });
        this.pendingForApprovals();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description
          );
        }

        modal.onClose = () => this.closeModal();
        this.setState({ modal });
      });
  };

  render() {
    const { contentReady, modal, user, readOnly, modulo, errors } = this.state;

    return (
      <div>
        {contentReady && (
          <div id="user-provider">
            <div className="header-title flex-element">
              <div className="title gest-client flex-element">
                <img src={Provider} />
                <p className="client-gest">
                  {i18next.t("providers.users.title")}
                </p>
                {moduleAction(this.props.roles, MOD_PROVID, WRITE) && (
                  <div>
                    {readOnly === true && (
                      <div className="new-edit-div-client user-div">
                        {this.props.user.reverseUser == true && (
                          <>
                            <img
                              src={iconCredentials}
                              className="iconEdit credentials"
                              onClick={() =>
                                this.resetCredentialsFunction(user.idUser)
                              }
                            />
                            <p
                              className="new-edit-provider credentials"
                              onClick={() =>
                                this.resetCredentialsFunction(user.idUser)
                              }
                            >
                              Recuperar Credenciales
                            </p>
                          </>
                        )}

                        <p
                          className="new-edit-provider"
                          onClick={() => this.setState({ readOnly: false })}
                        >
                          Editar
                        </p>
                        <img
                          src={iconEdit}
                          className="iconEdit"
                          onClick={() => this.props.changeInfo()}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              {formOptions.map(({ name, placeholder }) => (
                <React.Fragment key={name}>
                  <CustomInput
                    name={name}
                    className="input col-lg-6 col-user-provider"
                    inputClass="input-fix-user-provider"
                    label={i18next.t(`general.placeholders.${placeholder}`)}
                    value={user[name]}
                    onChange={this.handlerChange}
                    readOnly={readOnly}
                    error={errors[name]}
                  />
                  {this.pendingData(name)}
                </React.Fragment>
              ))}

              <div className="input col-lg-6 col-user-provider">
                <label className="label label-user-provider">
                  {i18next.t("general.labels.state")}
                </label>
                <CustomSelect
                  id="companyStatus"
                  className={`input input--text input-w-aux__input input--active as input-fix-user-provider`}
                  items={[
                    { name: "Activo", value: "ACTIVE" },
                    { name: "Inactivo", value: "INACTIVE" },
                    { name: "Eliminar", value: "DELETED" },
                    { name: "Bloqueado", value: "BLOCKED" },
                  ]}
                  name="companyStatus"
                  value={user.companyState}
                  valueAttr={"value"}
                  handleChange={(event) => this.SelectedStatus(event)}
                  readOnly={readOnly}
                />
                {this.pendingData("companyStatus")}
              </div>
            </div>
            <div className="clearfix">
              {modulo.map((mod, key) => (
                <div key={`${mod.id}-${key}`} className="loaded-module-user">
                  <div className="flex-element">
                    <p>{mod.displayName}</p>
                    {/* {this.pendingData(mod.id)} */}
                  </div>
                  <div className="roles">
                    {mod.permissions.map((permission, moduleKey) => (
                      <CheckBox
                        key={`${moduleKey}-${permission.code}-${permission.code}`}
                        id={`${permission.id}-${permission.id}`}
                        name={`${key}-${moduleKey}`}
                        label={permission.displayName}
                        checked={permission.assigned}
                        disabled={permission.code === "S" ? true : readOnly}
                        onChange={(event) => this.moduleHandlerChange(event)}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="form-actions clearfix">
              {readOnly === true ? (
                <button
                  className={`button button--pill btnLimpiar`}
                  onClick={() => this.props.returnTable()}
                >
                  {i18next.t("general.buttons.back")}
                </button>
              ) : (
                <>
                  <button
                    className={`button button--pill btnLimpiar`}
                    onClick={() => this.props.returnTable()}
                  >
                    {i18next.t("general.buttons.cancel")}
                  </button>
                  <button
                    className={`button button--pill btnAgregar fix-client-button`}
                    onClick={(event) => this.UpdateProviderUser(event)}
                  >
                    {i18next.t("general.buttons.sendForApproval")}
                  </button>
                </>
              )}
            </div>
          </div>
        )}
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </div>
    );
  }
}

const formOptions = [
  { name: "firstName", placeholder: "name" },
  { name: "lastName", placeholder: "last_name" },
  { name: "id", placeholder: "id" },
  { name: "phone", placeholder: "phone" },
  { name: "email", placeholder: "email" },
];

export const mapStateToProps = (state) => {
  return {
    userInfo: getUserByCode(state),
    roles: getRoles(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(UserActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(ProviderUserInfo)
);
